import { IFlagData } from '@common/interfaces/bbc'
import { INote } from '@common/interfaces/notes'
import orderBy from 'lodash/orderBy'
import { IAction } from '../apiMiddleware'

export const addNoteSuccess = (state: IFlagData, action: IAction<INote>) => {
  const noteData = action.data
  const data = state?.data
  if (!data || !noteData) return state
  let newData
  if (noteData.parentId) {
    newData = data.map((item) =>
      item.notes?.id === noteData.parentId
        ? {
            ...item,
            notes: {
              ...item.notes,
              children: [...item.notes.children, noteData],
            },
          }
        : item,
    )
  } else if (data && noteData.flagId) {
    newData = data.map((item) =>
      item.id === noteData.flagId
        ? {
            ...item,
            notes: { ...noteData, children: [] },
          }
        : item,
    )
  } else if (data && noteData.entityFlagId) {
    newData = data.map((item) =>
      item.id === noteData.entityFlagId
        ? {
            ...item,
            notes: { ...noteData, children: [] },
          }
        : item,
    )
  }
  return {
    ...state,
    data: newData,
  }
}

export const deleteNoteSuccess = (state: IFlagData, action: IAction<INote>) => {
  const noteData = action.data
  const data = state?.data
  if (!data || !noteData) return state
  let newData
  if (noteData.parentId) {
    newData = data.map((item) => {
      if (item.notes?.id === noteData.parentId) {
        return {
          ...item,
          notes: {
            ...item.notes,
            children: item.notes.children.filter((child) => child.id !== noteData.id),
          },
        }
      } else {
        return item
      }
    })
  } else {
    newData = data.filter((item) => item.id !== noteData.id)
  }
  return {
    ...state,
    data: newData,
  }
}

export const updateNoteSuccess = (state: IFlagData, action: IAction<INote>) => {
  const noteData = action.data
  const data = state?.data
  if (!data || !noteData) return state
  let newData
  if (noteData.parentId) {
    newData = data.map((item) => {
      if (item.notes?.id === noteData.parentId) {
        return {
          ...item,
          notes: {
            ...item.notes,
            children: orderBy(
              item.notes.children.map((child) => {
                return child.id === noteData.id ? noteData : child
              }),
              ['pinned', 'resolved', 'createdAt'],
              ['asc', 'desc', 'asc'],
            ),
          },
        }
      } else {
        return item
      }
    })
  } else {
    newData = orderBy(
      data.map((item) => {
        if (item.id === noteData.id) {
          return noteData
        }
        return item
      }),
      ['pinned', 'resolved', 'createdAt'],
      ['desc', 'asc', 'desc'],
    )
  }
  // These helpers are shared across the INote and IFlag list reducers, so the
  // replaced item can be a note; cast back to the caller's element type.
  return {
    ...state,
    data: newData as typeof data,
  }
}
